module.exports = __webpack_public_path__ + "static/Galanogrotesque-Light-acfab56ed04a523a47dd133f2a7591de.woff";